import { QueryCache, QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { ErrorType } from "src/types/apiResponse";

export const ErrorToast = (error: any | Error) => {
  const errorMessage =
    (error as ErrorType)?.response?.data?.message ?? error.message;

  if (!["Token expired", "No credential provided"].includes(errorMessage)) {
    window.scrollTo(0, 0);

    toast.error(errorMessage, {
      position: "top-center",
      style: {
        backgroundColor: "#FFE7E7",
        color: "#A85E5E",
      },
    });
  }
};

/**
 * The counterpart to ErrorToast, for edits that save without leaving the page.
 *
 * Same surface as the error toast so the two read as one system. A toast rather than the
 * success modal: a modal is right for finishing a flow, but wrong for a single field the
 * admin is going to keep editing — it stops them to acknowledge something they can see.
 */
export const SuccessToast = ({ message }: { message: string }) => {
  toast.success(message, {
    position: "top-center",
    style: {
      backgroundColor: "#E7F5EC",
      color: "#3F7A55",
    },
  });
};

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error: any | Error) => ErrorToast(error),
  }),
});

export default queryClient;

export const reactQueryOptions = {
  retry: 3,
  staleTime: 1000,
};
